import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from './assets/logofinal-thmb.png';
import { useTranslation } from 'react-i18next';
import { useAuth } from './AuthContext';
import NotificationCenter from './NotificationCenter';
import DashboardSearch from './DashboardSearch';
import './Navbar.css';
import { useLocation } from 'react-router-dom';

function Navbar({ onLogout = () => { } }) {
  const auth = useAuth();
  const { i18n } = useTranslation();
  const location = useLocation();
  const isDashboardFiltered = location.pathname === '/dashboard' && location.search.includes('filter=');
  const [profile, setProfile] = useState(null);
  const token = auth?.token;
  const user = auth?.user;
  const tokenParsed = user || {};
  const groups = tokenParsed?.groups || [];
  const normalizedGroups = groups?.map((g) => g.replace(/^\//, '')) || [];
  const isMaintainer = normalizedGroups.includes('maintainer');
  const isScreenwriter = normalizedGroups.includes('screenwriter');
  const username = tokenParsed?.preferred_username || 'Utilisateur';

  const handleLogout = () => {
    localStorage.removeItem('kc_token');
    localStorage.removeItem('kc_refreshToken');
    localStorage.removeItem('kc_user');
    window.location.href = '/';
  };

  useEffect(() => {
    if (!token) return;
    fetch("/myProfil", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => setProfile(data))
      .catch((err) => console.error("Erreur profil", err));
  }, [token]);

  return (
    <div className="d-flex flex-column" >
      {/* 🔎 Zone de recherche visible en haut */}


      {/* Barre horizontale sticky alignée à droite */}
     <div
  style={{
    position: 'fixed',
    top: '50px',
    left: 80,
    right: 0,
    height: '80px',
    zIndex: 1045,
    backgroundColor: 'transparent'
  }}
>
  <DashboardSearch
    onSearch={(query) => console.log("Recherche:", query)}
    initiallyCollapsed={isDashboardFiltered}
  />
</div>


      <div
        className="topbar-navbar"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: '70px',
          zIndex: 1030,
          paddingLeft: '80px',
          paddingRight: '20px',
          backgroundColor: 'white',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)'  // 2% opacity = ultra subtle
        }}
      >

        <div className="dropdown me-3">
          <button
            className="btn d-flex align-items-center gap-2 p-0 border-0 bg-transparent"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              src={profile?.avatar_url
                ? `${profile.avatar_url}`
                : "https://via.placeholder.com/40?text=?"}
              className="rounded-circle avatar-img"
              style={{ width: 48, height: 48, objectFit: 'cover' }}
            />
          </button>
          <ul className="dropdown-menu dropdown-menu-end shadow rounded-4 p-3" style={{ minWidth: 250 }}>
            <div className="text-center mb-3">
              <img
                src="https://ui-avatars.com/api/?name=Akrem+A&background=ffffff&color=0d1b2a"
                className="rounded-circle mb-2"
                style={{ width: 56, height: 56 }}
                alt="User avatar"
              />
              <div className="fw-bold">{tokenParsed?.name || username}</div>
              <div className="text-muted small">{tokenParsed?.email || "user@email.com"}</div>
            </div>
            <li>
              <Link to="/account" className="dropdown-item d-flex align-items-center gap-2">
                <i className="bi bi-person-gear"></i> Mon Compte
              </Link>
            </li>
            <li><hr className="dropdown-divider" /></li>
            <li className="text-center mt-2">
              <button className="btn btn-outline-danger btn-sm rounded-pill w-100" onClick={handleLogout}>
                🔓 Déconnexion
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Barre verticale gauche */}
      <nav
        className="d-flex flex-column align-items-start bg-light vh-100 p-3 shadow"
        style={{ width: '80px', position: 'fixed', top: 0, left: 0, zIndex: 1040 }}
      >
        <Link to="/dashboard" className="mb-4 d-flex align-items-center text-decoration-none">
          <img src={logo} alt="Logo" style={{ height: 40, width: 40 }} />
        </Link>

        <ul className="nav flex-column w-100 gap-4">
          <li title="Accueil">
            <Link className="nav-link text-dark d-flex justify-content-center" to="/dashboard">
              <i className="bi bi-house fs-4"></i>
            </Link>
          </li>
          {isScreenwriter && (
            <li title="Démarrer une histoire">
              <Link className="nav-link text-dark d-flex justify-content-center" to="/wizard">
                <i className="bi bi-magic fs-4"></i>
              </Link>
            </li>
          )}
          <li title="Suivi de production">
            <Link className="nav-link text-dark d-flex justify-content-center" to="/production">
              <i className="bi bi-bar-chart fs-4"></i>
            </Link>
          </li>
          <li title="Tous les médias">
            <Link className="nav-link text-dark d-flex justify-content-center" to="/admin">
              <i className="bi bi-collection-play fs-4"></i>
            </Link>
          </li>
        </ul>

        <div className="mt-4 d-flex flex-column align-items-center gap-4 w-100">
          <button
            className="btn rounded-circle d-flex align-items-center justify-content-center"
            title="Changer la langue"
            style={{
              width: 40,
              height: 40,
              backgroundColor: 'transparent',
              border: 'none',
              color: '#000000',
              fontWeight: 'bold',
              fontSize: '0.9rem',
              padding: 0
            }}
            onClick={() => i18n.changeLanguage(i18n.language === 'fr' ? 'en' : 'fr')}
          >
            {i18n.language === 'fr' ? 'FR' : 'EN'}
          </button>

          <Link to="/notifications" className="position-relative" title="Voir les notifications">
            <NotificationCenter />
          </Link>
        </div>

        <div className="mt-auto d-flex flex-column align-items-center gap-3 py-4 w-100">
          <div className="dropup w-100 text-center">
            <button
              className="btn p-0 border-0 w-100 d-flex justify-content-center"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              title="Paramètres"
            >
              <i className="bi bi-gear fs-4"></i>
            </button>
            <ul className="dropdown-menu shadow rounded-4 p-2">
              <li>
                <Link to="/settings" className="dropdown-item d-flex align-items-center gap-2">
                  <i className="bi bi-sliders2"></i> Paramètres
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <main style={{ marginLeft: '80px', paddingTop: '360px', paddingRight: '20px' }}>
        {/* Contenu des routes */}
      </main>
    </div>
  );
}

export default Navbar;
